import { XIcon } from 'lucide-react'

import { SharePercentInput } from '@/components/freight/SharePercentInput'
import { Button } from '@/components/ui/button'
import { Slider } from '@/components/ui/slider'
import { type Share } from '@/lib/freightAllocation'

interface FreightShareRowProps {
  share: Share
  disabled?: boolean
  /** A single freight type is always 100%. */
  fixed?: boolean
  onSlideStart: () => void
  onSlide: (value: number) => void
  onSlideEnd: () => void
  onPercentCommit: (value: number) => void
  onRemove: () => void
}

/** One freight type: name, share slider, exact percentage and remove; in a list narrower than 32rem the slider wraps under the name. */
export function FreightShareRow({
  share,
  disabled,
  fixed,
  onSlideStart,
  onSlide,
  onSlideEnd,
  onPercentCommit,
  onRemove,
}: FreightShareRowProps) {
  return (
    <li className="grid grid-cols-[minmax(0,1fr)_auto_auto] items-center gap-x-3 gap-y-1 px-2 py-1.5 @lg:grid-cols-[minmax(0,12rem)_minmax(8rem,1fr)_auto_auto]">
      <span className="text-md min-w-0 truncate md:text-sm" title={share.name}>
        {share.name}
      </span>
      <Slider
        className="order-last col-span-3 @lg:order-none @lg:col-span-1"
        value={[share.percentage]}
        step={1}
        disabled={disabled || fixed}
        aria-label={`${share.name} share`}
        aria-valuetext={`${share.percentage}%`}
        onPointerDown={onSlideStart}
        onPointerUp={onSlideEnd}
        onPointerCancel={onSlideEnd}
        onValueChange={([next]) => onSlide(next)}
      />
      <SharePercentInput
        name={share.name}
        value={share.percentage}
        disabled={disabled || fixed}
        onCommit={onPercentCommit}
      />
      <Button
        type="button"
        variant="ghost"
        size="icon-sm"
        aria-label={`Remove ${share.name}`}
        disabled={disabled}
        onClick={onRemove}
      >
        <XIcon />
      </Button>
    </li>
  )
}
